import AccountNavigation from '../../../../components/molecules/account/accountNavigation';
import AccountPage from '../../../../components/molecules/account/accountPage';
import { checkUserForRedirect } from '../../../../components/molecules/account/checkUserForRedirect';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React, { useEffect, useMemo, useState } from 'react';
import app from '@frontastic/catwalk/src/js/app/app';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../../../components/molecules/account/accountNavigation/_vars';
import proxyFetch from '@frontastic/bridge/js/fetch';

const AccountNavigationTastic = ({ data, context, isServerSideRendering }) => {
  const isSSR = typeof isServerSideRendering === 'boolean' && isServerSideRendering;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const {
    session: {
      account: { firstName, projectSpecificData },
    },
  } = context;

  const accountId = projectSpecificData && projectSpecificData.customerNumber;
  const [token, setToken] = useState();
  const dispatch = useDispatch();
  const { omneo } = useSelector((state) => state.app.context.project.configuration);

  useEffect(() => {
    if (accountId) {
      proxyFetch(`/custom_api/commercetools/customer/getOmneoToken`, { method: 'POST' })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then((body) => {
          if (!body.data?.token) {
            return;
          }
          setToken(body.data.token);
          dispatch({
            type: 'common.omneo.access',
            data: { apiToken: body.data.token },
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!isSSR) {
      if (window.innerWidth > 767) {
        app.getRouter().replace('Frontastic.Frontend.Master.Account.profile');
      }
    }
    checkUserForRedirect(context.session.loggedIn);
  }, [isSSR]);

  const omneoAccountLink = useMemo(
    () =>
      accountId &&
      `https://my.${theme.toLowerCase()}.com.au/login?token=${btoa(token)}&mode=null&enableAppointment=null&externalRedirect=null`,
    [token],
  );

  return (
    <AccountPage onlyWrap>
      <AccountNavigation
        accountId={accountId}
        omneoAccountLink={omneoAccountLink}
        userName={firstName}
        omneo={omneo}
        token={token}
      />
    </AccountPage>
  );
};

export default tastify({
  translate: true,
  connect: { isServerSideRendering: true, context: true },
})(AccountNavigationTastic);
